



































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 *  Used to render a tile, including a selected and internal state.
 */
@Component
export default class Tile extends Vue {

    @Prop({ type: Boolean })
    private selected!: boolean;

    @Prop({ type: Boolean })
    private noSelectedIcon!: boolean;

    @Prop({ type: Boolean })
    private internal!: boolean;

    @Prop({ type: Boolean })
    private warning!: boolean;

    @Prop({ type: String })
    private title!: string;

    @Prop({ type: Array })
    private paddingless!: Array<string>;

    /**
     *  Used to get the fact if the content should be paddingless.
     */
    private get paddinglessContent(): boolean {

        return this._paddingless('content');

    }

    /**
     *  Used to get the fact if the footer should be paddingless.
     */
    private get paddinglessFooter(): boolean {

        return this._paddingless('footer');

    }

    /**
     *
     *  Internal method to check if the paddingless Array contains
     *  a specific key: it something should be paddingless.
     *
     *  @param key The key to check if present in the paddingless Array
     *
     *  @returns If the key is present in the Array (if it should be paddingless)
     *
     */
    private _paddingless(key: string): boolean {

        return Array.isArray(this.paddingless) ? this.paddingless.includes(key) : false;

    }

}
